import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	text-align: left;
	padding: 0 0 ${helpers.spacing.xxLarge};
`
